'use strict';

// picturefill isn't an es6 module, so grab everything as picturefill
import * as picturefill from 'picturefill';

// invoke picturefill globally before anything
picturefill();

// URLSearchParams will self-invoke if required
import 'url-search-params-polyfill';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

// our polyfills will self-invoke if required
import 'utils/polyfills';

// widgets will invoke themselves
// vue widgets?

import {init as toggle} from 'modules/toggle';
import {init as tabbing} from 'modules/tabbing';
import {init as accordion} from 'modules/accordion';
import {init as messages} from 'modules/messages';
import {init as videoModal} from 'modules/video-modal';
import {init as inlineYoutubeVideo} from 'modules/inline-youtube-video';
import {init as inlineVimeoVideo} from 'modules/inline-vimeo-video';
import {init as scroller} from 'modules/scroller';
import {init as imageGallery} from 'modules/image-gallery';
import {init as footer} from 'modules/footer';
import {init as countingStats} from 'modules/counting-stats';
import {init as animatedScroll} from 'modules/animated-scroll';
import {init as aos } from 'modules/aos';
import {init as globalNavigation } from 'modules/global-navigation';
import {init as scrollTo } from 'modules/scroll-to';
import {init as concertNav } from 'modules/concert-nav';
import {init as categorySwitch } from 'modules/category-switch';
import {init as membershipLevels } from 'modules/membership-levels';
import {init as donate } from "modules/donate";
import {init as userStatus} from 'modules/user-status';
import {init as audioPlayer} from 'modules/audio-player';
import {init as inlineModal} from 'modules/inline-modal';
import {init as newsletter} from 'modules/newsletter';
import {init as newsletterPopup} from 'modules/newsletter-popup';
import {init as infiniteScroll} from 'modules/infinite-scroll';
import {init as artistList} from 'modules/artist-list';

// Vue widgets
import './widgets/bootstrap';

// To make sure the code is run AFTER VueJS is loaded
// Code in imported modules is run asynchronously so cannot control the order but will ALWAYS run before the file doing the import
window.addEventListener('load', function () {
    toggle();
    tabbing();
    accordion();
    messages();
    videoModal();
    inlineYoutubeVideo();
    inlineVimeoVideo();
    scroller();
    imageGallery();
    footer();
    countingStats();
    animatedScroll();
    aos();
    globalNavigation();
    scrollTo();
    concertNav();
    categorySwitch();
    membershipLevels();
    donate();
    userStatus();
    audioPlayer();
    inlineModal();
    newsletter();
    newsletterPopup();
    infiniteScroll();
    artistList();
});
